import styled from 'styled-components'
import { Button } from '../common/Button'

export const GoogleButton = styled(({ href, ...rest }) => (
  <Button
    look="white"
    bordered
    iconLeft={<img src="/static/google-logo.svg" width="24" height="24" />}
    href={href}
    {...rest}
  />
))`
  width: 20rem;
`
